function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ae31680d53"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c77f1934ff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 187.5 37.5 C 104.65625 37.5 37.5 104.65625 37.5 187.5 C 37.5 270.34375 104.65625 337.5 187.5 337.5 C 270.34375 337.5 337.5 270.34375 337.5 187.5 C 337.5 104.65625 270.34375 37.5 187.5 37.5 Z M 187.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "373117a2dd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 126.675781 124.140625 L 248.175781 124.140625 L 248.175781 250.890625 L 126.675781 250.890625 Z M 126.675781 124.140625 ",
  clipRule: "nonzero"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ae31680d53)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c77f1934ff)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f882",
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  transform: "matrix(0.75, 0, 0, 0.75, 37.500002, 37.499998)",
  fill: "none",
  strokeLinejoin: "miter",
  d: "M 200.00001 0.00000328333 C 89.54167 0.00000328333 -0.00000271667 89.541676 -0.00000271667 200.000016 C -0.00000271667 310.458357 89.54167 400.00003 200.00001 400.00003 C 310.458351 400.00003 400.000024 310.458357 400.000024 200.000016 C 400.000024 89.541676 310.458351 0.00000328333 200.00001 0.00000328333 Z M 200.00001 0.00000328333 ",
  stroke: "#ffffff",
  strokeWidth: 36,
  strokeOpacity: 1,
  strokeMiterlimit: 4
})));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 162.671875 183.777344 L 176.324219 183.777344 C 177.695312 183.777344 178.808594 182.664062 178.808594 181.292969 C 178.808594 179.921875 177.695312 178.8125 176.324219 178.8125 L 162.671875 178.8125 C 161.300781 178.8125 160.191406 179.921875 160.191406 181.292969 C 160.191406 182.664062 161.300781 183.777344 162.671875 183.777344 Z M 162.671875 183.777344 ",
  fillOpacity: 1,
  fillRule: "nonzero"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 155.226562 181.292969 C 155.226562 179.921875 154.113281 178.8125 152.742188 178.8125 L 139.089844 178.8125 C 137.71875 178.8125 136.605469 179.921875 136.605469 181.292969 C 136.605469 182.664062 137.71875 183.777344 139.089844 183.777344 L 152.742188 183.777344 C 154.113281 183.777344 155.226562 182.664062 155.226562 181.292969 Z M 155.226562 181.292969 ",
  fillOpacity: 1,
  fillRule: "nonzero"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#373117a2dd)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 248.316406 149.023438 C 248.316406 135.332031 237.179688 124.195312 223.492188 124.195312 C 222.101562 124.195312 163.710938 124.195312 161.429688 124.195312 C 155.957031 124.195312 151.5 128.652344 151.5 134.125 L 151.5 158.953125 L 129.160156 158.953125 C 127.789062 158.953125 126.675781 160.0625 126.675781 161.433594 L 126.675781 191.222656 C 126.675781 192.59375 127.789062 193.707031 129.160156 193.707031 L 151.5 193.707031 L 151.5 240.871094 C 151.5 246.347656 155.957031 250.800781 161.429688 250.800781 L 218.527344 250.800781 C 224.003906 250.800781 228.457031 246.347656 228.457031 240.871094 L 228.457031 173.347656 C 239.773438 171.039062 248.316406 161.011719 248.316406 149.023438 Z M 161.429688 129.160156 L 208.613281 129.160156 C 203.84375 132.746094 200.402344 138.003906 199.167969 144.054688 L 156.464844 144.054688 L 156.464844 134.125 C 156.464844 131.390625 158.695312 129.160156 161.429688 129.160156 Z M 183.773438 163.917969 L 183.773438 168.882812 L 131.640625 168.882812 L 131.640625 163.917969 Z M 131.640625 173.847656 L 183.773438 173.847656 L 183.773438 188.742188 L 131.640625 188.742188 Z M 218.527344 245.835938 L 161.429688 245.835938 C 158.695312 245.835938 156.464844 243.609375 156.464844 240.871094 L 156.464844 230.941406 L 223.492188 230.941406 L 223.492188 240.871094 C 223.492188 243.609375 221.265625 245.835938 218.527344 245.835938 Z M 223.492188 225.976562 L 156.464844 225.976562 L 156.464844 193.707031 L 186.253906 193.707031 C 187.625 193.707031 188.738281 192.59375 188.738281 191.222656 L 188.738281 161.433594 C 188.738281 160.0625 187.625 158.953125 186.253906 158.953125 L 156.464844 158.953125 L 156.464844 149.023438 L 198.667969 149.023438 C 198.667969 162.710938 209.804688 173.847656 223.492188 173.847656 Z M 223.492188 168.882812 C 212.542969 168.882812 203.632812 159.972656 203.632812 149.023438 C 203.632812 138.070312 212.542969 129.160156 223.492188 129.160156 C 234.441406 129.160156 243.351562 138.070312 243.351562 149.023438 C 243.351562 159.972656 234.441406 168.882812 223.492188 168.882812 Z M 223.492188 168.882812 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 231.046875 140.75 L 219.769531 152.027344 L 215.9375 148.195312 C 214.96875 147.226562 213.398438 147.226562 212.429688 148.195312 C 211.457031 149.167969 211.457031 150.738281 212.429688 151.707031 L 218.011719 157.292969 C 218.984375 158.261719 220.554688 158.261719 221.523438 157.292969 L 234.558594 144.261719 C 235.527344 143.292969 235.527344 141.71875 234.558594 140.75 C 233.585938 139.78125 232.015625 139.78125 231.046875 140.75 Z M 231.046875 140.75 ",
  fillOpacity: 1,
  fillRule: "nonzero"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 196.183594 235.90625 L 183.773438 235.90625 C 182.402344 235.90625 181.289062 237.019531 181.289062 238.390625 C 181.289062 239.761719 182.402344 240.871094 183.773438 240.871094 L 196.183594 240.871094 C 197.554688 240.871094 198.667969 239.761719 198.667969 238.390625 C 198.667969 237.019531 197.554688 235.90625 196.183594 235.90625 Z M 196.183594 235.90625 ",
  fillOpacity: 1,
  fillRule: "nonzero"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 181.289062 139.089844 L 193.703125 139.089844 C 195.074219 139.089844 196.183594 137.980469 196.183594 136.609375 C 196.183594 135.238281 195.074219 134.125 193.703125 134.125 L 181.289062 134.125 C 179.917969 134.125 178.808594 135.238281 178.808594 136.609375 C 178.808594 137.980469 179.917969 139.089844 181.289062 139.089844 Z M 181.289062 139.089844 ",
  fillOpacity: 1,
  fillRule: "nonzero"
});
function SvgIcono1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono1);
export default __webpack_public_path__ + "static/media/icono1.dea3cb6a5150fa1b98f1b9681ab310b0.svg";
export { ForwardRef as ReactComponent };